import { connect, ConnectedProps } from 'react-redux'
import { DropDownWithSearchBar } from '../../../../../forms/CustomSelect/DropDown'
import { dictionaryComplexFromJsonArr } from '../../../../../utils/globals/dictionary'
import { PdfTemplatePayload, PdfTemplateResult } from '../../../../../utils/reducers/company/pdfTemplates'
import withLoading from '../../../../../utils/hoc/withLoading'
import { AllReduxPayloads } from '../../../../../utils/reducers'
import './orderbuttons.sass'
import TwinIcon, { TwinIconProp, TwinIconToolTip } from '../../../../../baseComponents/TwinIcon'
import { faCircleInfo, faList, faSplit } from '@fortawesome/pro-light-svg-icons'
import { CsvOrderTemplatePayload } from '../../../../../utils/reducers/company/csvOrderTemplates'
import { ModalOpenedTy } from '../../../../../baseComponents/Modal/types'
import { Fragment, useState } from 'react'
import ModalDivideIntoChaptersOrder from './ModalsOrderButtons/ModalDivideIntoChaptersOrder'
import { InputTableLayoutData, OrderHeaderURLs } from '../../../../../baseComponents/TwinTable/InputTableLayout/types'
import { OrderData } from '../types'
import { UserPermissions } from '../../../../../baseComponents/CreateRoutering/types'
import ModalVariablesOrder from './ModalsOrderButtons/ModalVariablesOrder'
import ModalProductTypesOrder from './ModalsOrderButtons/ModalProductTypesOrder'

export interface ButtonOrderInfoLeftBaseProps {
    disabled: boolean
    infoMessage: string
    children?: React.ReactNode
}

export const ButtonOrderInfoLeftBase: React.FC<ButtonOrderInfoLeftBaseProps> = ({ disabled, infoMessage, children }) => {
    return (
        <div className='flex items-center'>
            {disabled ?
                <TwinIconToolTip id='errorQuote' message={infoMessage} icon={faCircleInfo} classNameIcon='text-red-BA regular22 mr-10' />
                :
                null
            }
            {children}
        </div>
    )
}
interface OrderSelectorPdfTemplateProps extends ReduxOrderSelectorPdfTemplate  {
    downloadPdfWithTemplate: (value: string | number) => void
    myref: any
    typeTemplate: keyof PdfTemplateResult
}

export const OrderSelectorPdfTemplate: React.FC<OrderSelectorPdfTemplateProps> = ({ downloadPdfWithTemplate, myref, pdfTemplates, typeTemplate }) => {
    const dictPdfOrderTemplates = dictionaryComplexFromJsonArr(pdfTemplates?.[typeTemplate] || {})
    return (
        <div className='searcher_pdf_order_template mt-10 absolute right-0 w-130 z-9'>
            <div ref={myref} className='flex relative searcher_pdf_order_container'>
                <DropDownWithSearchBar items={dictPdfOrderTemplates} onChange={downloadPdfWithTemplate} value={''} />
                <a className='hidden downloadfile' download={true} href='/' target='_blank' onClick={(e) => e.stopPropagation()}>a</a>
            </div>
        </div>
    )
}

interface ProcessButtonProps {
    finalizeOrder: (url: string, navigateUrl: string) => Promise<void>
    url: string
    text: string
    icon: TwinIconProp
    navigateTo: string
    messageError?: string
}

export const ProcessButton: React.FC<ProcessButtonProps> = ({ finalizeOrder, url, text, icon, navigateTo, messageError }) => {
    const className = messageError ? 'process_button_disabled py-10 text-gray-F7' : 'process_button py-20'
    return (
        <div onClick={() => messageError ? {} : finalizeOrder(url, navigateTo)} className={'order_process_button flex flex-col px-10 flex-auto cursor-pointer ' + className || ''} >
            {messageError ? <TwinIconToolTip message={messageError} id={text} icon={faCircleInfo} className='ml-auto' classNameIcon='w-18 h-18' /> : null}
            <TwinIcon icon={icon} className='w-30 h-30 m-auto mb-20' />
            {text}
        </div>
    )
}

const pdfTemplateDispatch = {
    setPdfTemplates: (payload: PdfTemplatePayload) => ({ type: 'CHANGE_PDFTEMPLATE', payload }),
}

export type ReduxOrderSelectorPdfTemplate = ConnectedProps<typeof orderSelectorPdfTemplateConnect>
const mapOrderSelectorPdfTemplateConnector = (state: AllReduxPayloads) => ({ pdfTemplates: state.pdfTemplates })
const orderSelectorPdfTemplateConnect = connect(mapOrderSelectorPdfTemplateConnector, pdfTemplateDispatch)
const orderSelectorPdfTemplateConnectLoading = withLoading(OrderSelectorPdfTemplate, [{ fetchUrl: '/api/app/config/pdfTemplate/getAllPdfTemplates', propName: 'pdfTemplates', setFunctionName: 'setPdfTemplates' }])
const OrderSelectorPdfTemplateConnect = orderSelectorPdfTemplateConnect(orderSelectorPdfTemplateConnectLoading)

interface OrderSelectorCsvTemplateProps extends ReduxOrderSelectorCsvTemplate {
    downloadCsvWithTemplate: (value: string | number) => void
    myref: any
}

const OrderSelectorCsvTemplate: React.FC<OrderSelectorCsvTemplateProps> = ({ downloadCsvWithTemplate, myref, csvOrderTemplates }) => {
    return (
        <div className='searcher_pdf_order_template mt-10 absolute right-0 w-130 z-9'>
            <div ref={myref} className='flex relative searcher_pdf_order_container'>
                <DropDownWithSearchBar items={csvOrderTemplates || {}} onChange={downloadCsvWithTemplate} value={''} />
                <a className='hidden downloadfile' download={true} href='/' target='_blank' onClick={(e) => e.stopPropagation()}>a</a>
            </div>
        </div>
    )
}

const csvOrderTemplateDispatch = {
    setCsvOrderTemplates: (payload: CsvOrderTemplatePayload) => ({ type: 'CHANGE_CSV_ORDER_TEMPLATE', payload }),
}

interface OrderVariablesAndChaptersButtonProps {
    allRowData: OrderData
    onSubmit: () => void
    children?: React.ReactNode
    title: string
    id: string
    isReadOnly?: boolean
    orderHeaderURLs: OrderHeaderURLs
    setCompleteData: React.Dispatch<React.SetStateAction<InputTableLayoutData | null>>
    updateHeaderData: string
    userPermissions: UserPermissions
}

export const OrderVariablesButton: React.FC<OrderVariablesAndChaptersButtonProps> = ({ allRowData, onSubmit, children, id, title, ...logic }) => {
    const { opened, setOpened } = useOrderVariablesButtonLogic()
    return (
        <Fragment>
            <div onClick={() => setOpened(true)}>
                {children ?? <TwinIconToolTip classNameIcon='hover:text-green-43 regular20' message={title} icon={faList} id={id} />}
            </div>
            {opened ? <ModalVariablesOrder getCompleteData={onSubmit} headerData={allRowData?.header} setOpened={setOpened} onSubmit={() => { }} {...logic} /> : null}
        </Fragment>
    )
}

const useOrderVariablesButtonLogic = () => {
    const [opened, setOpened] = useState<ModalOpenedTy>(null)
    return { opened, setOpened }
}

export const OrderDivideIntoChaptersButton: React.FC<OrderVariablesAndChaptersButtonProps> = ({ allRowData, onSubmit, children, id, title, isReadOnly, ...logic }) => {
    const { opened, setOpened } = useOrderDivideIntoChaptersButtonLogic()
    return (
        <Fragment>
            <div onClick={() => setOpened(true)}>
                {children ?? <TwinIconToolTip classNameIcon='hover:text-green-43 regular22' message={title} icon={faSplit} id={id} />}
            </div>
            {opened ? <ModalDivideIntoChaptersOrder getCompleteData={onSubmit} headerData={allRowData?.header} setOpened={setOpened} onSubmit={() => { }} isReadOnly={isReadOnly} {...logic} /> : null}
        </Fragment>
    )
}

const useOrderDivideIntoChaptersButtonLogic = () => {
    const [opened, setOpened] = useState<ModalOpenedTy>(null)
    return { opened, setOpened }
}

interface OrderProductTypesButtonProps {
    allRowData: OrderData
    onSubmit: () => void
    children?: React.ReactNode
    title: string
    id: string
    isReadOnly?: boolean
    orderHeaderURLs?: OrderHeaderURLs
    setCompleteData?: React.Dispatch<React.SetStateAction<InputTableLayoutData | null>>
    updateHeaderData?: string
    userPermissions?: UserPermissions
}

export const OrderProductTypesButton: React.FC<OrderProductTypesButtonProps> = ({ allRowData, onSubmit, children, id, title, ...logic }) => {
    const { opened, setOpened } = useOrderProductTypesButtonLogic()
    return (
        <Fragment>
            <div onClick={() => setOpened(true)}>
                {children ?? <TwinIconToolTip classNameIcon='hover:text-green-43 regular20' message={title} icon={faList} id={id} />}
            </div>
            {opened ? <ModalProductTypesOrder getCompleteData={onSubmit} headerData={allRowData?.header} setOpened={setOpened} onSubmit={onSubmit} {...logic} /> : null}
        </Fragment>
    )
}

const useOrderProductTypesButtonLogic = () => {
    const [opened, setOpened] = useState<ModalOpenedTy>(null)
    return { opened, setOpened }
}


export type ReduxOrderSelectorCsvTemplate = ConnectedProps<typeof csvOrderSelectorTemplateConnect>
const mapCsvOrderSelectorTemplateConnector = (state: AllReduxPayloads) => ({ csvOrderTemplates: state.csvOrderTemplates })
const csvOrderSelectorTemplateConnect = connect(mapCsvOrderSelectorTemplateConnector, csvOrderTemplateDispatch)
const csvOrderSelectorTemplateConnectLoading = withLoading(OrderSelectorCsvTemplate, [{ fetchUrl: '/api/app/config/csvOrderTemplate/getAllCsvOrderTemplates', propName: 'csvOrderTemplates', setFunctionName: 'setCsvOrderTemplates' }])
export const CsvOrderSelectorTemplateConnect = csvOrderSelectorTemplateConnect(csvOrderSelectorTemplateConnectLoading)

export default OrderSelectorPdfTemplateConnect
